export var Paths = {
    uploadFile: "/RSP/File/UploadRSP"
};
export var Deploy = {
    live: "http://localhost:3003/",
    testpool: "http://localhost:3003/",
    dev: "/",
    development: "/",
    stage: "https://client-smsonedev.sms-assist.com/"
};
export var RES_PATH = process.env.RES_PATH;
